import { Link } from "react-router-dom";
import { Home, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] grid place-items-center relative overflow-hidden">
      <div className="absolute -top-24 -left-24 h-96 w-96 blob-saffron opacity-70 pointer-events-none" />
      <div className="absolute -bottom-24 -right-24 h-96 w-96 blob-cream opacity-60 pointer-events-none" />
      <div className="relative mx-auto max-w-2xl px-4 sm:px-6 text-center">
        <div className="font-display text-[10rem] md:text-[14rem] font-bold tracking-tighter leading-none text-saffron-accent">404</div>
        <h1 className="mt-2 font-display text-3xl md:text-4xl font-semibold tracking-tight text-navy-800">This page doesn't exist yet.</h1>
        <p className="mt-3 text-navy-600 max-w-md mx-auto">The page you're looking for may have moved or the link may be broken. Let's get you back on track.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button asChild className="btn-saffron rounded-2xl h-11 px-6 font-semibold" data-testid="not-found-home">
            <Link to="/"><Home className="h-4 w-4 mr-2" /> Return home</Link>
          </Button>
          <Button asChild variant="outline" className="btn-navy-outline border-2 rounded-2xl h-11 px-6 font-semibold">
            <Link to="/explore"><Compass className="h-4 w-4 mr-2" /> Explore campaigns</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
